import React, { Component, useReducer } from 'react';
import {Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import {Triangle } from 'react-loader-spinner'

  class Scheduler extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        day: '',
        start_time: '',
        end_time: '',
        title: '',
        audience: '',
        audience_selection: '',
        client: '',
        loading: false
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.AddToSchedule = (e) =>{
        this.setState({loading: true})
        e.preventDefault()
        var start = this.state.day + ' ' + this.state.start_time + ':00'
        var end = this.state.day + ' ' + this.state.end_time + ':00'
        var title = this.state.title
        var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        var resizable = false
        var start_resizable = false

        const { cookies } = this.props;
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('start', start)
        data.append('end', end)
        data.append('title', title)
        data.append('timezone', timezone)
        data.append('resizable', resizable)
        data.append('start_resizable', start_resizable)
        var audience = ''
        if (this.state.audience == ''){
          audience = 'all'
        }
        data.append('audience', audience)
        
        axios.post(Backend_Url + 'addToSchedule', data)
        .then((res) => {
            let result = res.data
            alert(title + ' added to schedule successfully.')
            this.setState({loading: false})
            window.location.reload()
        }).catch((error) => {
            alert('An error occured while trying to add ' + title + ' to the schedule.')
            this.setState({loading: false})
        })
      }

      this.AddClientToAudience = (email) => {
        var current_audience = this.state.audience

        if(current_audience == ''){
          this.setState({audience: email + ''})
        }else{
          var update = current_audience + ' ' + email
          this.setState({audience: update})
        }
        alert(email + " has been added to the stream's audience.")
        this.setState({client: ''})
      }

      this.ClientDropdown = () => {
        var client_ = this.state.client

        if(client_ == ''){
          return<div></div>
        }else{
          var clients = this.props.all_clients
      
          var matches = []
          clients.map((client, index) => {
              var email = client.email.toLowerCase()
      
              var res = email.includes(client_.toLowerCase())
              if(res == true){
                  matches.push(client)
              }
          })

          if(matches.length == 0){
            return<div>
              <br/>
              No matches found
            </div>
          }else{
            var clients_map = matches.map((client, index) => {
              return<Row style={{margin: '5px', borderBottom: '1px solid grey'}}>
                <Button onClick={() => this.AddClientToAudience(client.email)} style={{border: 'none', width: '100%', backgroundColor: 'inherit', color: 'inherit'}}>
                  {client.email}
                </Button>
              </Row>
            })
    
            return<div>
              {clients_map}
            </div>
          }
        }
      }

      this.ClientsSearchRender = () => {
        var audience_selection = this.state.audience_selection
        if(audience_selection == 'client'){
          return<div>
            Search using client's email address
            <br/>
            <Input name='client' value={this.state.client} onChange={this.HandleChange} type='text' placeholder='Client email'
              style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
            <this.ClientDropdown/>
            <br/>
            Added: {this.state.audience}
          </div>
        }else{
          return<div>

          </div>
        }
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0)
    }




    render() {
      if (this.state.loading == true){
        return<div style={{backgroundImage: "url(" + Background_Image + ")", margin: '0px', minHeight: '550px'}}>
          <div style={{backgroundColor: '#ffffff', minHeight: '550px', opacity: 0.9, minHeight: '1000px'}}>
            <Container style={{textAlign: 'center', alignItems: 'center', justifyContent: 'center'}}>
              <br/>
              <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                ONFIT
              </h1>
              <br/><br/>
              <Triangle
                  color="#1FACED"
                  height={130}
                  width={130}
              />
              <h3 style={{marginTop: '50px', color: '#1FACED'}}>
                Loading...
              </h3>
              <h6 style={{marginTop: '50px'}}>
                  Taking too long to load? Check your internet connection and reload the page.
              </h6>
              <br/><br/>
            </Container>
          </div>
        </div>
      }
      return (
        <Row>
            <Helmet>
              <title>TRAINER SCHEDULER - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Scheduler
              </h4>
              <br/><br/><br/><br/>
              <Container>
                <Row>
                  <Col sm='4'>
                    <h6>
                      Select Day
                    </h6>
                    <br/>
                    <input name="day" value={this.state.day} onChange={this.HandleChange} type="date"
                    style={{width: '70%'}}/>
                    <br/><br/>
                  </Col>
                  <Col sm='4'>
                    <h6>
                      Select Start Time
                    </h6>
                    <br/>
                    <input name="start_time" value={this.state.start_time} onChange={this.HandleChange} type="time"
                    style={{width: '70%'}}/>
                    <br/><br/>
                  </Col>
                  <Col sm='4'>
                    <h6>
                      Select End Time
                    </h6>
                    <br/>
                    <input name="end_time" value={this.state.end_time} onChange={this.HandleChange} type="time"
                    style={{width: '70%'}}/>
                    <br/><br/>
                  </Col>
                </Row>
                <Row>
                    <Col sm='6'>
                    <br/>
                      <select name='audience_selection' value={this.state.audience_selection} onChange={this.HandleChange} type='text'
                      style={{border: 'none', borderBottom: '1px solid grey', width: '100%', backgroundColor: 'inherit', marginTop: '7px'}}>
                          <option value=''>Select Session Audience</option>
                          <option value='all'>All users</option>
                          <option value='client'>Specific Client(s)</option>
                      </select>
                      <br/><br/>
                    </Col>
                    <Col sm='6'>
                      <this.ClientsSearchRender/>
                      <br/><br/>
                    </Col>
                </Row>
                <Row>
                  <Col sm='6'>
                    <h6>
                      Title
                    </h6>
                    <br/>
                    <input name="title" value={this.state.title} onChange={this.HandleChange} type="text"
                    style={{width: '70%'}}/>
                    <br/><br/>
                  </Col>
                  <Col sm='6'>
                    <Button onClick={this.AddToSchedule} style={{marginTop: '50px', border: 'none', backgroundColor: '#1faced', color: '#ffffff', width: '50%', borderRadius: '20px'}}>
                      Add To Schedule
                    </Button>
                  </Col>
                  <Col>
                  
                  </Col>
                </Row>
              </Container>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(Scheduler);